import { authFetch } from '../utils/authFetch';
import { baseUrl } from '../utils/requestUrl';

export const getClinicalLocations = async (siteId) => {
    const response = await authFetch(`${baseUrl}/clinicalSites/${siteId}/clinicalLocations`);
    return response.json();
};
